import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el producto?',
  a: 'Recibirás acceso inmediato en formato digital apenas completes tu compra.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema está diseñado tanto para principiantes como para personas con experiencia.'
}, {
  q: '¿Necesito equipamiento?',
  a: 'No. Puedes empezar desde casa sin máquinas ni equipamiento caro.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: 'Las rutinas son flexibles y se adaptan a horarios reales.'
}, {
  q: '¿Los bonus vienen incluidos?',
  a: 'Sí. Los 3 bonus están incluidos sin costo extra.'
}, {
  q: '¿Qué diferencia tiene con videos de YouTube?',
  a: 'Aquí tienes un sistema estructurado y organizado paso a paso para evitar perder tiempo improvisando.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-20 px-4 bg-zinc-900/30" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-3xl md:text-5xl font-bebas text-white text-center mb-6 md:mb-12" data-id="element-56">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-57">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className={`bg-zinc-900 border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-brand-500/50' : 'border-zinc-800'}`} data-id="element-58">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 py-3.5 md:px-6 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-59">
                  <span className="font-bold text-white text-sm md:text-base pr-3" data-id="element-60">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 shrink-0 transition-all duration-300 ${isOpen ? 'rotate-180 text-brand-500' : 'text-zinc-500'}`} data-id="element-61" />
                </button>
                <AnimatePresence data-id="element-62">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-63">
                      <div className="px-4 pb-3.5 md:px-6 md:pb-5 text-zinc-400 text-xs md:text-base border-t border-zinc-800/50 pt-3 md:pt-4" data-id="element-64">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}